import {api,apiErrorMessage, getApiBase} from "./api";
import {customerServiceTestSessionSchema,type CustomerServiceTestSession} from "@wenjing/contract/customer-service";
import type {ChatRequest} from "./customer-service-conversation";

const sessionKey = "wenjing_customer_chat_test";
export type CustomerChatSession = {token:string} & Partial<Omit<CustomerServiceTestSession,"token">>;
export class CustomerChatError extends Error {
  constructor(message: string, public status: number, public payload: Record<string, unknown>) { super(message); }
}
export function readCustomerChatSession(): CustomerChatSession | null {
  try {
    const token=new URLSearchParams(location.hash.slice(1)).get("testToken");
    if(token){const value={token};saveCustomerChatSession(value);history.replaceState(history.state,"",location.pathname+location.search);return value;}
    const value = JSON.parse(sessionStorage.getItem(sessionKey) || "null");
    return value?.mode==="test" && typeof value.token==="string" && value.token ? value : null;
  } catch { return null; }
}
export function saveCustomerChatSession(value: CustomerChatSession | null) {
  if (value) sessionStorage.setItem(sessionKey, JSON.stringify({...value,mode:"test"})); else sessionStorage.removeItem(sessionKey);
}
export async function createCustomerTestSession(){return customerServiceTestSessionSchema.parse(await api("/api/marketing/customer-service/test-sessions",{method:"POST",body:"{}"}));}
export function customerTestUrl(session:CustomerServiceTestSession){return "/customer-chat-test#testToken="+encodeURIComponent(session.token);}
// 不通过后台 api() 注入 token；匿名请求也绝不继承后台登录。
export function customerChatRequest(token = "",conversationId=""): ChatRequest {
  return async <T,>(path: string, options: RequestInit = {}) => {
    if(conversationId){
      const id=encodeURIComponent(conversationId);
      if(path===`/api/marketing/customer-service/conversations/${id}`)path="/api/marketing/customer-service/test-session/conversation";
      else if(path===`/api/ai/conversations/${id}/messages`)path="/api/marketing/customer-service/test-session/messages";
    }
    const headers = new Headers(options.headers);
    headers.set("Content-Type", "application/json");
    if (token) headers.set("Authorization", `Bearer ${token}`); else headers.delete("Authorization");
    if (typeof options.body === "string") {
      const body = JSON.parse(options.body);
      if (body.idempotencyKey) headers.set("Idempotency-Key", body.idempotencyKey);
    }
    let response: Response;
    try { response = await fetch(`${getApiBase()}${path}`, {...options,headers,cache:"no-store",credentials:"omit"}); }
    catch (cause) { throw new CustomerChatError(cause instanceof Error ? `连接失败：${cause.message}` : "连接失败，请稍后重试", 0, {}); }
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new CustomerChatError(apiErrorMessage(payload, response.status), response.status, payload);
    return payload as T;
  };
}
